import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _CalendarDateTimeInput_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
/* import __COLOCATED_TEMPLATE__ from './calendar-date-time-input.hbs'; */
/* global Pikaday:true */
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { action } from "@ember/object";
import { isEmpty } from "@ember/utils";
import { Promise } from "rsvp";
import loadScript from "discourse/lib/load-script";
import I18n from "discourse-i18n";
import TEMPLATE from "./calendar-date-time-input.hbs";
import { setComponentTemplate } from "@ember/component";
let CalendarDateTimeInput = (_class = (_CalendarDateTimeInput_brand = /*#__PURE__*/new WeakSet(), class CalendarDateTimeInput extends Component {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _CalendarDateTimeInput_brand);
    _defineProperty(this, "_timeFormat", this.args.timeFormat || "HH:mm:ss");
    _defineProperty(this, "_dateFormat", this.args.dateFormat || "YYYY-MM-DD");
    _defineProperty(this, "_dateTimeFormat", this.args.dateTimeFormat || "YYYY-MM-DD HH:mm:ss");
    _defineProperty(this, "_picker", null);
    _initializerDefineProperty(this, "_time", _descriptor, this);
    _initializerDefineProperty(this, "_date", _descriptor2, this);
  }
  setupInternalDateTime() {
    this._time = this.args.time;
    this._date = this.args.date;
  }
  setupPikaday(element) {
    _assertClassBrand(_CalendarDateTimeInput_brand, this, _setupPicker).call(this, element).then(picker => {
      this._picker = picker;
    });
  }
  onChangeTime(event) {
    this._time = event.target.value;
    this.args.onChangeTime(this._time);
  }
  changeDate() {
    if (moment(this.args.date, this._dateFormat).isValid()) {
      this._date = this.args.date;
      this._picker.setDate(moment.utc(this._date).format(this._dateFormat), true);
    } else {
      this._date = null;
      this._picker.setDate(null);
    }
  }
  changeTime() {
    if (isEmpty(this.args.time)) {
      this._time = null;
      return;
    }
    if (/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(this.args.time)) {
      this._time = this.args.time;
    }
  }
  changeMinDate() {
    if (this.args.minDate && moment(this.args.minDate, this._dateFormat).isValid()) {
      this._picker.setMinDate(moment(this.args.minDate, this._dateFormat).toDate());
    } else {
      this._picker.setMinDate(null);
    }
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_time", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_date", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setupInternalDateTime", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setupInternalDateTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setupPikaday", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setupPikaday"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChangeTime", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChangeTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "changeDate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "changeDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "changeTime", [action], Object.getOwnPropertyDescriptor(_class.prototype, "changeTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "changeMinDate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "changeMinDate"), _class.prototype)), _class);
function _setupPicker(element) {
  return new Promise(resolve => {
    loadScript("/javascripts/pikaday.js").then(() => {
      const options = {
        field: element.querySelector(".fake-input"),
        container: element.querySelector(`#picker-container-${this.args.datePickerId}`),
        bound: false,
        format: "YYYY-MM-DD",
        reposition: false,
        firstDay: 1,
        setDefaultDate: true,
        keyboardInput: false,
        i18n: {
          previousMonth: I18n.t("dates.previous_month"),
          nextMonth: I18n.t("dates.next_month"),
          months: moment.months(),
          weekdays: moment.weekdays(),
          weekdaysShort: moment.weekdaysMin()
        },
        onSelect: date => {
          const formattedDate = moment(date).format("YYYY-MM-DD");
          this.args.onChangeDate(formattedDate);
        }
      };
      resolve(new Pikaday(options));
    });
  });
}
export { CalendarDateTimeInput as default };
setComponentTemplate(TEMPLATE, CalendarDateTimeInput);